import { useQuery } from '@tanstack/react-query'
import { getEventByIdService } from '@/services/events'

export const eventDetailsQueryKey = (agendaId: string, eventId: string) => [
  'agendas',
  agendaId,
  'events',
  eventId,
]

export const useEventDetails = (agendaId: string, eventId: string) =>
  useQuery({
    queryKey: eventDetailsQueryKey(agendaId, eventId),
    queryFn: () => getEventByIdService(agendaId, eventId),
  })
